import * as Yup from 'yup';
import Translator from '../../core/i18n';
const T = Translator.create();
export function getValidationAdminCourseProgressReport() {

    return Yup.object()
        .shape({
            selectedCourses: Yup.string(),
            selectedClasses: Yup.string(),
            selectedUsers: Yup.string(),
            selectedPrograms: Yup.string(),
            selectedUnits: Yup.string()
        })
        .test(
            'oneOfRequired',
            T.t('r_validation_report_one_of_required'),
            // tslint:disable-next-line: only-arrow-functions
            function(item: any) {
                return (item.selectedCourses || item.selectedClasses || item.selectedUsers || item.selectedPrograms || item.selectedUnits);
            }
        );
    }
    
    